/**
 * PwaAnalyticsBridge — listens for window CustomEvents emitted by the
 * PwaInstallProvider / SaveToPhoneModal and POSTs them to
 * `/api/pwa/events`. One event -> one row -> one dashboard metric. Keeps
 * all PWA telemetry on the LifeGuide side and tagged `app="lifeguide"` so
 * it never commingles with I Need a Proverb activity.
 *
 * No PII beyond the current session's auth header (if present). Failures
 * are swallowed — this is best-effort telemetry.
 */
import { useEffect } from "react";
import { pwa as pwaApi } from "../lib/api";

const EVENT_MAP = {
  "pwa:save-prompt-shown":       "save_prompt_shown",
  "pwa:save-prompt-clicked":     "save_prompt_clicked",
  "pwa:save-prompt-dismissed":   "save_prompt_dismissed",
  "pwa:ios-instructions-shown":  "ios_instructions_shown",
  "pwa:install-accepted":        "android_install_accepted",
  "pwa:install-dismissed":       "android_install_dismissed",
  "pwa:standalone-launch":       "standalone_launch",
};

function platform() {
  const ua = (navigator.userAgent || "").toLowerCase();
  if (/ipad|iphone|ipod/.test(ua)) return "ios";
  if (/android/.test(ua)) return "android";
  return "web";
}

export default function PwaAnalyticsBridge() {
  useEffect(() => {
    const handlers = Object.entries(EVENT_MAP).map(([evt, type]) => {
      const h = (e) => {
        try {
          pwaApi
            .trackEvent({
              event_type: type,
              trigger: e?.detail?.trigger || null,
              kind: e?.detail?.kind || null,
              hide_days: typeof e?.detail?.hideDays === "number" ? e.detail.hideDays : null,
              platform: platform(),
              display_mode:
                window.matchMedia?.("(display-mode: standalone)")?.matches
                  ? "standalone"
                  : "browser",
            })
            .catch(() => {});
        } catch { /* swallow */ }
      };
      window.addEventListener(evt, h);
      return [evt, h];
    });
    return () => handlers.forEach(([evt, h]) => window.removeEventListener(evt, h));
  }, []);
  return null;
}
